import React from "react";
import "./coaches.css";
import Navbar from "../../Components/NavbarCustom";
import Banner from "../../Components/Coaches/Banner";
import Footer from "../../Components/Footer";
import Grid from "../../Components/Coaches/Grid";
import SEO from "../../Components/SEO";

function Coaches() {
  return (
    <div className="coaches">
      <SEO
        title="BWC Sports | Coaches"
        description=""
        url="https://bwcsports.com/coaches"
      />

      <Banner />
      <div className="coaches-text">
        <p className="coaches-line1 black-text-clip">
          Meet the passionate and experienced coaches who are dedicated to
          helping your
        </p>
        <p className="coaches-line2 black-text-clip">
          child grow, learn, and shine through sports.
        </p>
      </div>
      <Grid />
    </div>
  );
}

export default Coaches;
